export enum TypeReport {
    anac_bagage = "ANAC - Bagagens",
    anac_inspac = "ANAC - INSPAC",
    anac_pnae = "ANAC - Passageiros PNAE",
    resume_boarding = "Resumo de Embarque",
    resume_pax_boarding = "Resumo de Passageiros Embarcados"
}